var _WidgetDescriptor_id, _WidgetDescriptor_initPos, _WidgetDescriptor_view, _WidgetDescriptor_getPos;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { uniqueId } from '../../../lodash';
import { removeDecoration } from './actions';
import { widgetDecorationPluginKey } from './plugin';
export class WidgetDescriptor {
    constructor(initPos, idPrefix) {
        _WidgetDescriptor_id.set(this, void 0);
        _WidgetDescriptor_initPos.set(this, void 0);
        _WidgetDescriptor_view.set(this, void 0);
        _WidgetDescriptor_getPos.set(this, void 0);
        __classPrivateFieldSet(this, _WidgetDescriptor_id, uniqueId(idPrefix), "f");
        __classPrivateFieldSet(this, _WidgetDescriptor_initPos, initPos, "f");
    }
    get id() {
        return __classPrivateFieldGet(this, _WidgetDescriptor_id, "f");
    }
    get initPos() {
        return __classPrivateFieldGet(this, _WidgetDescriptor_initPos, "f");
    }
    get view() {
        return __classPrivateFieldGet(this, _WidgetDescriptor_view, "f");
    }
    get getPos() {
        return __classPrivateFieldGet(this, _WidgetDescriptor_getPos, "f");
    }
    get pos() {
        var _a, _b;
        return (_b = (_a = this.getPos) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : this.initPos;
    }
    render(view, getPos) {
        __classPrivateFieldSet(this, _WidgetDescriptor_view, view, "f");
        __classPrivateFieldSet(this, _WidgetDescriptor_getPos, getPos, "f");
        return this.renderWidget(view, getPos);
    }
    applyTo(tr) {
        const meta = {
            type: 'add',
            descriptor: this,
        };
        return tr.setMeta(widgetDecorationPluginKey, meta);
    }
    rmDeco(tr) {
        return removeDecoration(tr, this.id);
    }
}
_WidgetDescriptor_id = new WeakMap(), _WidgetDescriptor_initPos = new WeakMap(), _WidgetDescriptor_view = new WeakMap(), _WidgetDescriptor_getPos = new WeakMap();
